import { useState } from 'react'
import {
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    IconButton,
    Typography,
} from '@mui/material'
import {
    AccountBalance,
    ContentCopy,
    Visibility,
    VisibilityOff,
} from '@mui/icons-material'

const currencyBRL = (n) =>
    (Number(n) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

const BalanceCard = ({ accountInfo, balance }) => {
    const [showBalance, setShowBalance] = useState(false)

    return (
        <Card
            sx={{
                border: '1px solid #E2E8F0',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                bgcolor: '#fff',
                borderRadius: 3,
                height: '100%',
                transition: 'box-shadow 0.2s ease, transform 0.2s ease',
                '&:hover': {
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    transform: 'translateY(-2px)',
                },
            }}
        >
            <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
                {/* Bank info */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                    <Box
                        sx={{
                            width: 44,
                            height: 44,
                            borderRadius: '12px',
                            bgcolor: '#3B82F615',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <AccountBalance sx={{ color: '#3B82F6' }} />
                    </Box>
                    <Box>
                        <Typography variant="body2" sx={{ color: '#1E293B', fontWeight: 600 }}>
                            {accountInfo?.bank?.name || 'Banco'}{' '}
                            {accountInfo?.bank?.code ? `- ${accountInfo.bank.code}` : ''}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#94A3B8' }}>
                            Ag: {accountInfo?.bank_branch || '---'} / Cc:{' '}
                            {accountInfo?.bank_account || '---'}
                        </Typography>
                    </Box>
                </Box>

                {/* Balance */}
                <Typography variant="body2" sx={{ color: '#64748B', fontWeight: 500, mb: 0.5 }}>
                    Saldo disponivel
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="h4" sx={{ fontWeight: 700, color: '#1E293B' }}>
                        {showBalance ? currencyBRL(balance) : 'R$ ••••••'}
                    </Typography>
                    <IconButton
                        onClick={() => setShowBalance((v) => !v)}
                        sx={{ color: '#94A3B8' }}
                        size="small"
                    >
                        {showBalance ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                </Box>

                {/* PIX key */}
                {accountInfo?.pix_key_company && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            mt: 2,
                            pt: 2,
                            borderTop: '1px solid #E2E8F0',
                        }}
                    >
                        <Chip
                            label="PIX"
                            size="small"
                            sx={{
                                bgcolor: '#22C55E14',
                                color: '#22C55E',
                                fontWeight: 600,
                                fontSize: '0.7rem',
                                border: '1px solid #22C55E30',
                            }}
                        />
                        <Typography
                            variant="caption"
                            sx={{ color: '#64748B', fontFamily: 'monospace' }}
                        >
                            {accountInfo.pix_key_company}
                        </Typography>
                        <IconButton
                            size="small"
                            onClick={() =>
                                navigator.clipboard.writeText(accountInfo.pix_key_company)
                            }
                            sx={{ color: '#94A3B8' }}
                        >
                            <ContentCopy sx={{ fontSize: 14 }} />
                        </IconButton>
                    </Box>
                )}

                {/* Link to statement */}
                <Button
                    href="/financeiro/extrato"
                    variant="text"
                    size="small"
                    sx={{
                        color: '#3B82F6',
                        textTransform: 'none',
                        fontWeight: 600,
                        mt: 2,
                        px: 0,
                    }}
                >
                    Ver extrato completo →
                </Button>
            </CardContent>
        </Card>
    )
}

export default BalanceCard
